import React from 'react'
import Success from '../../components/Users/CheckoutSuccess'
import NavBar from '../../components/Users/NavBar/NavBar'

const CheckoutSuccess = () => {
  return (
    <>
      <NavBar/>
      <Success/>
    </>
  )
}

export default CheckoutSuccess